module.exports = __webpack_public_path__ + "static/img/android.47854d1b.png";